/**
 * @module store/starts/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив организаторов стартов (текущую "страницу")
 *
 * @returns {array}
 */
const startsOrganizers = state => state.startsOrganizers;


/**
 * Getter: Возвращает системного организатора стартов
 *
 * @returns {object}
 */
const systemOrganizer = state => state.systemOrganizer;


/**
 * Getter: Возвращает общее число e-mails
 *
 * @returns {number}
 */
const startsOrganizersCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент e-mails
 *
 * @returns {boolean}
 */
const isStartsOrganizersLoading = state => state.isStartsOrganizersLoading;


export default {
  startsOrganizers,
  startsOrganizersCount,
  isStartsOrganizersLoading,
  systemOrganizer,
};
